export default __webpack_public_path__ + "static/banner-img-90f1d17cca44e31f4f65309772b40dcf.webp";